import { useQuery } from '@hooks/reactQuery';

import { getMoNames } from '@api/configurationComparison';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { IComparisonId } from '@interfaces/cmModule/dto/cmModuleDTO';

import { MO_NAMES } from '@constants/queryKeys';

interface IUseQueryMoTreeColumnNamesReturnType {
	moNames: string[];
	isLoadingMoNames: boolean;
}

export const UseQueryMoTreeColumnNames = (
	params: Partial<ICMMavenirVendor> & IComparisonId,
): IUseQueryMoTreeColumnNamesReturnType => {
	const { comparisonId, isMavenirVendor } = params;

	const {
		data: moNames,
		isInitialLoading: isLoadingMoNames,
	} = useQuery<string[]>({
		queryKey: [MO_NAMES],
		queryFn: () => getMoNames(comparisonId),
		enabled: [isMavenirVendor],
		refetchOnWindowFocus: false,
		refetchOnmount: false,
	});

	return {
		moNames: moNames || [],
		isLoadingMoNames,
	};
};
